import { useCallback } from "react";
import { useFolderTree } from "../../contexts/folderTree.js";
import { useTreeInteraction } from "../../contexts/treeInteraction.js";
function findSelectedNodeId(tree) {
    for (const node of tree){
        if (node.selected && node.id !== undefined) {
            return node.id;
        }
        const childId = findSelectedNodeId(node.childNodes ?? []);
        if (childId !== undefined) {
            return childId;
        }
    }
    return undefined;
}
function useFolderTreeRenameMode({ buttonId = "rename", canRenameNode: canRenameNodeOverride } = {}) {
    const { set, tree = [], canRenameNode: canRenameNodeFromContext } = useFolderTree();
    const { setRenamingNodeId } = useTreeInteraction();
    const canRenameNode = canRenameNodeOverride ?? canRenameNodeFromContext;
    const handleRenameNode = useCallback((shToolbarActiveButton, isCreatableLinkDisabled, isTreeLinkDisabled, renameNodeId)=>{
        set({
            toolbarActiveButton: shToolbarActiveButton,
            isCreatableLinkDisabled,
            isTreeLinkDisabled
        });
        setRenamingNodeId(renameNodeId);
    }, [
        set,
        setRenamingNodeId
    ]);
    const handleRenameClick = useCallback(()=>handleRenameNode(buttonId, true, true, findSelectedNodeId(tree)), [
        buttonId,
        handleRenameNode,
        tree
    ]);
    const handleRenameCancel = useCallback(()=>handleRenameNode(undefined, false, false, undefined), [
        handleRenameNode
    ]);
    const handleNodePressF2 = useCallback((node)=>{
        if (canRenameNode && !canRenameNode(node)) {
            return;
        }
        handleRenameNode(buttonId, true, true, node.id);
    }, [
        buttonId,
        canRenameNode,
        handleRenameNode
    ]);
    return {
        handleRenameClick,
        handleRenameCancel,
        handleNodePressF2
    };
}
export { useFolderTreeRenameMode };
